import { Text } from '@akin-home/text/native';
import { spacing } from '@akin-home/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import { RobotIdentity } from '../types';

interface RobotIdentityRowProps {
  identity: RobotIdentity;
  onPress?: () => any;
  selected?: boolean;
}

export const RobotIdentityRow = (props: RobotIdentityRowProps) => {
  const { identity, selected = false } = props;

  return (
    <Pressable
      style={({ pressed }) => ({ opacity: pressed ? 0.5 : 1 })}
      onPress={props.onPress}
    >
      <View style={styles.container}>
        <Text variant="p" weight={selected ? 'bold' : 'regular'}>
          {identity.name}
        </Text>
        {identity.is_primary_user ? (
          <FontAwesomeIcon
            icon={'star'}
            color="gold"
            style={styles.icon}
            size={25}
          />
        ) : null}
      </View>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: spacing[3],
    borderColor: '#dddddd',
    borderBottomWidth: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    marginLeft: 'auto',
  },
});
